<template>
    <div class="work-order-list">
        <!-- 搜索区域 -->
        <div class="search-wrapper">
            <el-form :model="searchForm" class="search-form" size="small" label-width="auto">
                <!-- 第一行 -->
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">工单编号</span>
                            <el-input v-model="searchForm.work_order_id" placeholder="请输入工单编号"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">ICCID</span>
                            <el-input v-model="searchForm.complaint_iccid" placeholder="请输入ICCID"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">登记人</span>
                            <el-input v-model="searchForm.loginUser" placeholder="请输入登记人"></el-input>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">来源渠道</span>
                            <el-select v-model="searchForm.source_no" placeholder="请选择来源渠道">
                                <el-option v-for="item in sourceChannelList" :key="item.itemValue"
                                    :label="item.itemLabel" :value="item.itemValue">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>

                </el-row>

                <!-- 第二行 -->
                <el-row :gutter="20">
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label process-type-label">处理类型</span>
                            <el-cascader
                            v-model="searchForm.process_type_no"
                            :options="handleTypeList"
                            :props="{ checkStrictly: true,emitPath: false }"
                            placeholder="请选择处理类型"
                            clearable
                            >

                        </el-cascader>

                        </div>
                    </el-col>

                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">工单状态 </span>
                            <el-select v-model="searchForm.status_no"  placeholder="请选择工单状态">
                                <el-option v-for="item in statusList" :key="item.itemValue"
                                    :label="item.itemLabel" :value="item.itemValue">
                                </el-option>
                            </el-select>
                        </div>
                    </el-col>
              
                    <el-col :span="6">
                        <div class="form-item-wrapper">
                            <span class="label">接单时间</span>
                            <el-date-picker v-model="searchForm.timeRange" type="daterange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div class="button-row">
                            <el-button type="primary" @click="handleSearch">查询</el-button>
                            <el-button @click="resetSearch">重置</el-button>
                        </div>
                    </el-col>
                </el-row>

                <!-- 按钮行 -->

            </el-form>
        </div>

        <!-- 表格区域 -->
        <div class="table-section">
            <div class="table-header">
                <div class="header-left">
                    <h3>工单列表</h3>
                    <span class="total-count">共 {{ total }} 条记录</span>
                </div>
                <div class="header-right">
                    <el-button type="primary" icon="el-icon-plus" @click="$router.push('/service/complaint')">
                        新增工单
                    </el-button>
                </div>
            </div>

            <!-- 替换表格为卡片列表 -->
            <div v-loading="loading" class="audit-list">
                <div v-if="tableData.length === 0" class="empty-data">
                    <el-empty description="暂无数据"></el-empty>
                </div>
                <template v-else>
                    <el-card v-for="item in tableData" :key="item.id" class="audit-item" shadow="hover">
                        <div class="info-container">
                            <div class="info-header">
                                <div class="header-left">
                                    <span class="order-time">
                                        <i class="el-icon-time"></i>
                                        创建时间：{{ formatRegDateTime(item.create_time) }}
                                    </span>
                                    <!-- <span class="creator">
                                        <i class="el-icon-user"></i>
                                        创建人：{{ item.creator || '-' }}
                                    </span> -->
                                    <el-tag size="small" :type="getStatusType(item.status_name)">
                                        处理结果：{{ item.status_name }}
                                    </el-tag>
                                </div>
                                <div class="header-right">
                                    <el-button type="text" size="small" @click="handleEdit(item)">
                                        <i class="el-icon-edit"></i> 编辑
                                    </el-button>
                                </div>
                            </div>

                            <div class="info-content">
                                <el-row :gutter="20">
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-document-copy"></i>
                                                工单编号：{{ item.orderNo }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-tickets"></i>
                                                投诉项目：{{ item.complaint_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-document"></i>
                                                处理类型：{{ item.process_type_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-cpu"></i>
                                                ICCID: {{ item.complaint_iccid }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-time"></i>
                                                工单时长：{{ calculateFlowTime(item.create_time) }}小时
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-position"></i>
                                                来源渠道：{{ item.source_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-office-building"></i>
                                                团队类型：{{ item.team_type_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-s-custom"></i>
                                                代理商：{{ item.representative_name }}
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-money"></i>
                                                收款金额：{{ item.payment_amount }}元
                                            </span>
                                        </div>
                                    </el-col>
                                    <el-col :span="6">
                                        <div class="info-item">
                                            <span class="value">
                                                <i class="el-icon-wallet"></i>
                                                客户付款：{{ item.customer_pay_amount }}元
                                            </span>
                                        </div>
                                    </el-col>
                                </el-row>
                                <el-row>
                                    <el-col :span="24">
                                        <div class="info-item desc-item">
                                            <span class="value">
                                                <i class="el-icon-warning-outline"></i>
                                                问题描述：{{ item.problem_desc }}
                                            </span>
                                        </div>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </el-card>
                </template>
            </div>

            <!-- 分页 -->
            <div class="pagination-container" v-if="total > 0">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[5, 10, 20, 30, 40]" :page-size="5"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

        <!-- 详情对话框 -->
        <el-dialog title="工单详情" :visible.sync="dialogVisible" width="70%" custom-class="tech-dialog"
            :close-on-click-modal="false">
            <div class="order-detail">
                <div class="order-card">
                    <!-- 添加工单编号显示 -->
                    <div class="order-number">
                        <span class="number">{{ currentOrder?.orderNo }}</span>
                        <!-- <el-tag 
                            :type="getStatusType(currentOrder?.status)" 
                            effect="dark" 
                            size="medium">
                            {{ currentOrder?.status }}
                        </el-tag> -->
                    </div>

                    <!-- 各个部分的内容 -->
                    <div class="detail-grid">
                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-message"></i>
                                投诉来源
                                <div class="title-line"></div>
                            </div>

                            <div class="section-content">
                                <div class="info-item">
                                    <label>来源渠道：</label>
                                    <span>{{ sourceChannel }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-warning"></i>
                                投诉级别
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>紧急程度：</label>
                                    <span>{{ urgencyLevel }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-time"></i>
                                投诉时间
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>问题发生时间：</label>
                                    <span>{{ issueTime }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-document"></i>
                                投诉项目
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>投诉项目：</label>
                                    <span>{{ complaintItem }}</span>
                                </div>
                                <div class="info-item" v-if="iccid">
                                    <label>ICCID:</label>
                                    <span>{{ iccid }}</span>
                                </div>
                                <div class="info-item" v-if="cardNumber">
                                    <label>开卡号码：</label>
                                    <span>{{ cardNumber }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-user"></i>
                                投诉用户
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>电话号码：</label>
                                    <span>{{ phoneNumber }}</span>
                                </div>
                                <div class="info-item">
                                    <label>ICCID：</label>
                                    <span>{{ userIccid }}</span>
                                </div>
                                <div class="info-item">
                                    <label>通道编码：</label>
                                    <span>{{ channelCode }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-s-custom"></i>
                                用户类型
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>用户类型：</label>
                                    <span class="text-left">{{ currentOrder?.teamType || '-' }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-office-building"></i>
                                代理商信息
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>代理商名称：</label>
                                    <span class="text-left">{{ agentName }}</span>
                                </div>
                            </div>
                            <div class="section-title">
                                <i class="el-icon-document"></i>
                                问题描述
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item description-item">
                                    <label>问题描述：</label>
                                    <div class="description-text">{{ currentOrder?.description || '暂无描述' }}</div>
                                </div>
                            </div>

                            <div class="section-title">
                                <i class="el-icon-user-solid"></i>
                                团队类型
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>团队类型：</label>
                                    <span class="text-left">{{ currentOrder?.teamType || '-' }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-document-copy"></i>
                                对账凭证分类
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="evidence-section">
                                    <div class="evidence-item">
                                        <h4>收款信息</h4>
                                        <div class="info-item">
                                            <label>收款金额：</label>
                                            <span>{{ receiptAmount }}</span>
                                        </div>
                                        <div class="info-item">
                                            <label>收款账户：</label>
                                            <span>{{ receiptAccount }}</span>
                                        </div>
                                        <div class="info-item">
                                            <label>交易订单号：</label>
                                            <span>{{ receiptOrderNo }}</span>
                                        </div>
                                    </div>
                                    <div class="evidence-item">
                                        <h4>付款信息</h4>
                                        <div class="info-item">
                                            <label>支付金额：</label>
                                            <span>{{ paymentAmount }}</span>
                                        </div>
                                        <div class="info-item">
                                            <label>支付账户：</label>
                                            <span>{{ paymentAccount }}</span>
                                        </div>
                                        <div class="info-item">
                                            <label>交易订单号：</label>
                                            <span>{{ paymentOrderNo }}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="section">

                            <div class="section-title">
                                <i class="el-icon-s-order"></i>
                                工单状态
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>工单状态：</label>
                                    <span class="status-text">{{ currentOrder?.status }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="section">
                            <div class="section-title">
                                <i class="el-icon-finished"></i>
                                投诉处理结果
                                <div class="title-line"></div>
                            </div>
                            <div class="section-content">
                                <div class="info-item">
                                    <label>处理类型：</label>
                                    <span class="text-left">{{ currentOrder?.handleType }}</span>
                                </div>
                                <div class="info-item">
                                    <label>处理结果：</label>
                                    <span class="text-left">{{ currentOrder?.handleResult || '暂无处理结果' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getDictData } from '@/api/dict'
import request from '@/utils/request'
import moment from 'moment'

export default {
    name: 'WorkOrderList',
    data() {
        return {
            loading: false,
            tableData: [],
            total: 0,
            currentPage: 1,
            searchForm: {
                page: 1,
                pagesize: 5,
                work_order_id: '',
                complaint_iccid: '',
                status_no: '',
                source_no: '',
                timeRange: [],
                start_time: '',
                end_time: '',
                process_type_no: ''
            },
            dialogVisible: false,
            currentOrder: null,
            sourceChannel: '客服热线',
            urgencyLevel: '紧急',
            issueTime: '2024-03-14 10:30:00',
            complaintItem: '物联网卡问题',
            iccid: '898600XXXXXXXXXX',
            cardNumber: '13800138000',
            phoneNumber: '13900139000',
            userIccid: '898600XXXXXXXXXX',
            channelCode: 'CH001',
            userType: '套餐用户',
            agentName: '某某科技有限公司',
            receiptAmount: '1000.00',
            receiptAccount: '6222XXXXXXXXXXXX',
            receiptOrderNo: 'RO2024031400001',
            paymentAmount: '1000.00',
            paymentAccount: '6222XXXXXXXXXXXX',
            paymentOrderNo: 'PO2024031400001',
            pickerOptions: {
                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                        picker.$emit('pick', [start, end])
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date()
                        const start = new Date()
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                        picker.$emit('pick', [start, end])
                    }
                }]
            },
            processResultList: [],
            handleTypeList: [],
            sourceChannelList: [],
            statusList:[]
        }
    },
    created() {
        this.loadConfig()
        this.getWorkOrderList()
    },
    mounted() {
      
    },
    methods: {
        //定义一个通用方法，根据类型获取字典数据
        async getDictData(_type) {
            const response = await getDictData(_type)
            if (response.status === 1) {
                return response.data
            }
        },
        transformDictDataFirstLevel(data) {
            return data.filter(item => item.parentId === '0')
        },

        // 转换字典数据为级联选择器格式
        transformDictData(data) {
            // 创建一个 Map 来存储所有节点
            const childrenMap = new Map();

            // 第一次遍历，初始化所有节点
            data.forEach(item => {
                const node = {
                    value: item.itemValue,
                    label: item.itemLabel,
                    children: []
                };
                // 使用 itemId 作为 key，因为 parentId 是引用 itemId
                childrenMap.set(item.itemId, node);
            });

            // 第二次遍历，建立父子关系
            data.forEach(item => {
                // 如果 parentId 不为 0，则建立父子关系
                if (item.parentId && item.parentId !== '0') {
                    const parentNode = childrenMap.get(item.parentId);
                    if (parentNode) {
                        parentNode.children.push(childrenMap.get(item.itemId));
                    }
                }
            });

            // 返回顶级节点（parentId 为 0 的节点）
            return data
                .filter(item => !item.parentId || item.parentId === '0')
                .map(item => childrenMap.get(item.itemId));
        },
        //加载配置数据
       async  loadConfig() {
            this.sourceChannelList =  await this.getDictData("KFTSLY")
            this.handleTypeList=await this.getDictData("KFTSLX")
            this.handleTypeList=  this.transformDictData(this.handleTypeList)
            this.processResultList=await this.getDictData("KFTSJG")
            this.processResultList=  this.transformDictData(this.processResultList)
            this.statusList=await this.getDictData("KFGDZT")
        },
       
        handleSearch() {
            // 处理时间范围
            if (this.searchForm.timeRange && this.searchForm.timeRange.length === 2) {
                this.searchForm.start_time = this.searchForm.timeRange[0];
                this.searchForm.end_time = this.searchForm.timeRange[1];
            }

            // 调用获取列表方法
            this.getWorkOrderList();
        },
        resetSearch() {
            this.searchForm = {
                page: 1,
                pagesize: 5,
                work_order_id: '',
                complaint_iccid: '',
                status_no: '',
                source_no: '',
                timeRange: [],
                start_time: '',
                end_time: '',
                process_type_no: '',
                loginUser: ''
            };
            this.getWorkOrderList();
        },
        handleSizeChange(val) {
            this.searchForm.pagesize = val;
            this.getWorkOrderList();
        },
        handleCurrentChange(val) {
            this.searchForm.page = val;
            this.getWorkOrderList();
        },
        async getWorkOrderList() {
            this.loading = true
            try {
                const response = await request({
                    url: '/api/v1/kf-work-order/page',
                    method: 'POST',
                    data: this.searchForm
                })

                console.log('API响应数据：', response) // 添加日志

                if (response.status === 1 && response.data) {
                    this.tableData = response.data.list || []
                    this.total = response.data.total || 0
                    console.log('工单列表数据：', this.tableData) // 添加日志
                } else {
                    this.$message.error(response.message || '获取数据失败')
                }
            } catch (error) {
                console.error('获取工单列表失败:', error)
                this.$message.error('获取数据失败')
            } finally {
                this.loading = false
            }
        },
        formatRegDateTime(time) {
            if (!time) return '--'
            return time.replace('T', ' ').split('+')[0]
        },
        isOverdue(createTime) {
            const now = new Date()
            const createDate = new Date(createTime)
            const diffHours = (now - createDate) / (1000 * 60 * 60)

            return diffHours > 24
        },
        getRowClassName({ row, rowIndex }) {
            if (this.currentPage === 1 &&
                row.status !== '已完结' &&
                this.isOverdue(row.createTime)) {
                return 'overdue-row'
            }
            return ''
        },
        handleView(row) {
            this.currentOrder = row
            this.dialogVisible = true
        },
        handleEdit(row) {
            this.$router.push({
                path: '/service/complaint',
                query: {
                    id: row.work_order_id,
                    type: 'edit'
                }
                
            })
        },
        handleDelete(row) {
            this.$confirm('确认删除该工单?', '提示', {
                type: 'warning'
            }).then(() => {
                this.$message.success('删除成功')
            }).catch(() => { })
        },

        //计算工单流转时长
        calculateFlowTime(createTime) {
            const now = new Date()
            const createDate = new Date(createTime)
            const diffHours = (now - createDate) / (1000 * 60 * 60)
            //大于24小时，显示天数
            if (diffHours > 24) {
                return Math.floor(diffHours / 24) + '天'
            }
            return diffHours.toFixed(2) 
        },

        // getUrgencyType(level) {
        //     const types = {
        //         '紧急': 'danger',
        //         '普通': 'warning',
        //         '低级': 'info'
        //     }
        //     return types[level] || 'info'
        // },
        // getStatusType(status) {
        //     const types = {
        //         '已登记': 'info',
        //         '处理中': 'warning',
        //         '已完结': 'success'
        //     }
        //     return types[status] || 'info'
        // },
        // (createTime) {
        //     if (!createTime) return '-';

        //     const now = new Date();
        //     const create = new Date(createTime);
        //     const diff = now - create;

        //     const hours = Math.floor(diff / (1000 * 60 * 60));

        //     if (hours >= 24) {
        //         return '24小时';
        //     } else {
        //         return `${hours}小时`;
        //     }
        // },
        getStatusType(status) {
            const types = {
                '待处理': 'warning',
                '处理中': 'primary',
                '已完成': 'success',
                '已关闭': 'info'
            }
            return types[status] || 'info'
        }
    }
}
</script>

<style scoped>
.work-order-list {
    padding: 20px;
    background-color: #f0f5ff;
}

.search-wrapper {
    background: #fff;
    padding: 20px;
    margin-bottom: 16px;
}

.search-form {
    background: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.el-row {
    margin-bottom: 10px;
}

.form-item-wrapper {
    display: flex;
    align-items: center;
    height: 34px;
    padding-left: 80px;
    position: relative;
    margin-bottom: 0;
}

.label {
    position: absolute;
    left: 0;
    color: #606266;
    font-size: 14px;
    white-space: nowrap;
    width: 80px;
    line-height: 32px;
    text-align: right;
    padding-right: 15px;
}

.el-input,
.el-select,
.el-date-editor {
    width: 240px !important;
    flex: none;
    height: 35px !important;
    line-height: 30px;
}

:deep(.el-input__inner) {
    height: 36px !important;
    line-height: 32px;
}

.el-input,
.el-select,
:deep(.el-date-editor) {
    margin-left: 15px;
}

/* 按钮行样式 */
.button-row {
    display: flex;
    justify-content: flex-end;
    height: 32px;
    line-height: 25px;
    padding-left: 20px;
}

/* 调整按钮之间的间距 */
.el-button+.el-button {
    margin-left:10px;
}

/* 行间距 */
.el-row:last-child {
    margin-bottom: 0;
}

.table-section {
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
}

.table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #e8f0ff;
    background: linear-gradient(to right, #f5f9ff, #fff);
    border-radius: 8px 8px 0 0;

    .header-left {
        display: flex;
        align-items: center;
        gap: 12px;

        h3 {
            font-size: 18px;
            color: #1a1a1a;
            position: relative;
            padding-left: 12px;
            margin: 0;
            display: flex;
            align-items: center;
            
            &:before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 4px;
                height: 16px;
                background: #409EFF;
                border-radius: 2px;
            }
        }

        .total-count {
            background: #f0f7ff;
            color: #409EFF;
            padding: 4px 12px;
            border-radius: 12px;
            font-size: 13px;
            margin-left: 12px;
            display: inline-flex;
            align-items: center;
            
            &:before {
                content: '';
                display: inline-block;
                width: 4px;
                height: 4px;
                background: #409EFF;
                border-radius: 50%;
                margin-right: 6px;
            }
        }
    }

    .header-right {
        .el-button {
            padding: 10px 20px;
            border-radius: 4px;
            font-weight: 500;
            transition: all 0.3s ease;
            
            i {
                margin-right: 6px;
            }

            &:hover {
                transform: translateY(-1px);
                box-shadow: 0 4px 12px rgba(64, 158, 255, 0.2);
            }
        }
    }
}

.audit-list {
    padding: 20px;
    background: #f8faff;
}

.audit-item {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    border: 1px solid #e8f0ff;
    transition: all 0.3s ease;
    
    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 16px rgba(64, 158, 255, 0.1);
    }

    .info-container {
        .info-header {
            background: #f8faff;
            padding: 16px 20px;
            border-bottom: 1px solid #e8f0ff;
        }

        .info-content {
            padding: 20px;

            .info-item {
                background: #f8faff;
                padding: 12px 16px;
                border-radius: 6px;
                margin-bottom: 12px;
                transition: all 0.3s ease;

                &:hover {
                    background: #f0f7ff;
                }
            }
        }
    }
}

/* 分页样式优化 */
.pagination-container {
    padding: 20px;
    background: #fff;
    border-top: 1px solid #e8f0ff;
    border-radius: 0 0 8px 8px;
}

.tech-dialog {
    border-radius: 8px;
    background: linear-gradient(to bottom, #ffffff, #f8faff);
    box-shadow: 0 12px 32px 4px rgba(0, 0, 0, .1);
}

.tech-dialog .el-dialog__header {
    background: linear-gradient(90deg, #f0f2f5, #e6e9f0);
    padding: 20px;
    border-bottom: 1px solid #ebeef5;
    border-radius: 8px 8px 0 0;
}

.tech-dialog .el-dialog__title {
    font-size: 18px;
    color: #2c3e50;
    font-weight: 600;
}

.order-detail {
    max-height: 70vh;
    overflow-y: auto;
    padding: 0 10px;
}

.order-number {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
    padding: 16px 20px;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #ebeef5;
}

.order-number .number {
    font-size: 20px;
    font-weight: 600;
    color: #2c3e50;
    font-family: 'Monaco', monospace;
}

.detail-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    padding: 0 20px;
}

.section {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.section-title {
    padding: 12px 15px;
    border-bottom: 1px solid #ebeef5;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 500;
    color: #303133;
    background-color: #fff;
}

.section-title i {
    margin-right: 8px;
    color: #409EFF;
}

.section-content {
    padding: 15px;
    background-color: #fff;
}

.info-item {
    display: flex;
    margin-bottom: 12px;
}

.info-item:last-child {
    margin-bottom: 0;
}

.info-item label {
    width: 100px;
    color: #909399;
    text-align: right;
    padding-right: 12px;
    flex-shrink: 0;
}

.info-item span {
    flex: 1;
    color: #2c3e50;
    text-align: left;
}

.text-left {
    text-align: left !important;
    word-break: break-all;
    white-space: normal;
    line-height: 1.5;
}

.el-tag {
    margin-left: 12px;
}

:deep(.el-tag) {
    border-radius: 4px;
    padding: 0 12px;
    height: 28px;
    line-height: 28px;
    font-weight: 500;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@media (prefers-color-scheme: dark) {
    .section {
        background: #1e1e1e;
        border-color: #333;
    }

    .info-item label {
        color: #909399;
    }

    .info-item span {
        color: #e0e0e0;
    }
}

.description-text {
    display: inline-block;
    width: 100%;

    text-overflow: ellipsis;
    white-space: nowrap;
}

:deep(.el-table__row) {
    line-height: 1.5;
}

:deep(.el-tooltip__popper) {
    max-width: 400px;
    line-height: 1.5;
    padding: 10px;
}

:deep(.el-table) {

    th.el-table__cell,
    td.el-table__cell {
        text-align: center !important;
    }

    .cell {
        text-align: center;
        display: inline-block !important;
        width: 100% !important;
    }
}

.sub-text {
    text-align: center;
    font-size: 12px;
    color: #909399;
    margin-top: 4px;
    width: 100%;
    display: inline-block;
}

.description-text {
    display: inline-block;
    width: 100%;
  
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
}

:deep(.el-table .cell) {
    display: flex;
    justify-content: center;
    align-items: center;
}

:deep(.el-table .cell .el-button--text) {
    margin: 0 5px;
}

.search-form .el-form-item {
    margin-bottom: 0;
    margin-right: 20px;
    text-align: left;
}

.table-header {
    text-align: center;
}

:deep(.el-tag) {
    display: inline-flex;
    justify-content: center;
    align-items: center;
}

:deep(.el-table .cell .el-button-group) {
    display: flex;
    justify-content: center;
    gap: 8px;
}

:deep(.el-tag) {
    display: inline-block;
}

:deep(.el-table__cell .cell .el-button) {
    padding: 0 8px;
}

:deep(.el-table__header-wrapper th) {
    font-weight: 500;
    color: #303133;
}

:deep(.el-table .cell .el-button-group) {
    text-align: center;
    width: 100%;
}

:deep(.el-table__row) {
    height: 50px;
}

.pagination-container {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #e8f0ff;
    text-align: right;
    display: flex;
    justify-content: flex-end;
}

:deep(.el-pagination) {
    white-space: nowrap;
    padding: 0;
    margin: 0;
    display: flex;
    align-items: center;
}

:deep(.el-pagination__total),
:deep(.el-pagination__sizes) {
    margin-right: 16px;
}

:deep(.el-pager li) {
    margin: 0 4px;
}

.overdue-row {
    background-color: #FFF3F3 !important;
}

.overdue-row:hover>td {
    background-color: #FFE7E7 !important;
}

.el-icon-warning {
    cursor: pointer;
}

.status-text {
    color: #2c3e50;
    font-size: 14px;
    line-height: 1.6;
}

.section {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ebeef5;
}

.section-content {
    padding: 15px;
    background-color: #fff;
}

.info-item {
    display: flex;
    margin-bottom: 12px;
    align-items: flex-start;
    background-color: #fff;
}

.status-text.processing {
    color: #409EFF;
}

.status-text.completed {
    color: #67C23A;
}

.status-text.pending {
    color: #E6A23C;
}

:deep(.el-table .cell) {
    white-space: nowrap;
   
    text-overflow: ellipsis;
}

.iccid-column {
    font-family: monospace;
}

.search-form {
    background-color: #fff;
    padding: 15px;
    margin-bottom: 15px;
    border-radius: 4px;
}

.el-form-item {
    margin-bottom: 15px;
}

.el-date-picker {
    width: 260px;
}

.el-select,
.el-cascader {
    width: 240px;
}

/* 调整日期选择器的宽度 */
:deep(.el-date-editor--daterange) {
    width: 100% !important;
}

/* 调整按钮组的位置 */
.operation-btns {
    display: flex;
    justify-content: flex-end;
    height: 100%;
    align-items: center;
}

.operation-btns .el-button {
    margin-left: 10px;
}

/* 专门针对处理类型标签的样式 */
.process-type-label {
    padding-right: 30px !important; /* 增加处理类型标签的右侧间距 */
}

.audit-list {
    margin: 20px 0;
}

.audit-item {
    margin-bottom: 16px;
    
    &:hover {
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }
}

.info-container {
    .info-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 1px solid #ebeef5;

        .header-left {
            display: flex;
            align-items: center;
            gap: 12px;

            .order-time, .creator {
                background: #f5f7fa;
                padding: 6px 12px;
                border-radius: 4px;
                color: #606266;
                font-size: 13px;
                display: inline-flex;
                align-items: center;
                gap: 4px;
                
                i {
                    color: #409EFF;
                    font-size: 14px;
                }
            }

            .creator {
                i {
                    color: #67C23A;  
                }
            }
        }
    }

    .info-content {
        .info-item {
            margin-bottom: 12px;
            
            .label {
                color: #909399;
                margin-right: 8px;
            }
            
            .value {
                color: #303133;
                font-weight: 500;
            }
            
            .sub-text {
                color: #909399;
                font-size: 12px;
                margin-left: 8px;
            }
        }
    }
}

.el-card {
    border-radius: 8px;
    
    &:hover {
        transition: all 0.3s;
    }
}

.el-tag {
    border-radius: 4px;
}

.empty-data {
    padding: 40px 0;
    text-align: center;
}

.info-item {
    .value {
        i {
            font-size: 16px;
            margin-right: 8px;

            /* 图标颜色定制 */
            &.el-icon-tickets {
                color: #409EFF;  
            }
            
            &.el-icon-document {
                color: #67C23A;  
            }
            
            &.el-icon-cpu {
                color: #E6A23C; 
            }
            
            &.el-icon-time {
                color: #909399; 
            }
            
            &.el-icon-office-building {
                color: #9C27B0;  
            }
            
            &.el-icon-s-custom {
                color: #2196F3;  
            }
            
            &.el-icon-money {
                color: #4CAF50;  
            }
            
            &.el-icon-warning-outline {
                color: #FF9800;  
            }
            &.el-icon-document-copy {
                color: #1976D2; 
            }
            &.el-icon-wallet {
                color: #795548; 
            }
            &.el-icon-position {
                color: #67C23A;  /* 使用绿色表示渠道 */
            }
        }
    }
}

/* 问题描述区域特殊样式 */
.desc-item {
    background: #fff8f0 !important;
    border-left: 4px solid #FF9800;
    
    .value {
        i {
            color: #FF9800 !important;
        }
    }
}
.el-main{
    background-color: #6993e7;
}
</style>
